exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.blog-page-posts-show img {\n  max-width: 100%;\n  height: auto;\n}\n", ""]);

// exports
